import React, { ReactElement } from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import RepliconNavigationTab from './RepliconNavigationTab';

export const RepliconMenuVisibleList = (props: {
  navigationMetadata: any;
  handleSettingsPopUp: any;
  isDocked: boolean;
}): ReactElement => {
  return (
    <>
      <List
        id="menuItems"
        className="mainMenuItems"
        sx={{
          paddingTop: '0px',
          ...(!props.isDocked && { height: '90vh' })
        }}
      >
        <Box
          className="menuList"
          sx={{
            margin: 0,
            listStyle: 'none',
            ...(!props.isDocked && { width: '240px' })
          }}
        >
          <a
            href={props.navigationMetadata?.freeTrialMetadata?.href?.toString()}
            id="FreeTrialButton"
            className="freeTrialButton"
            style={{ textDecoration: 'none' }}
          >
            {props.navigationMetadata?.freeTrialMetadata?.displayText}
          </a>
          <Box className="menuitem">
            <List>
              {props.navigationMetadata?.visibleTabs?.map((tab: any) => {
                return tab ? (
                  <ListItem
                    disablePadding
                    key={tab.id}
                    className={
                      tab.id === 'admin' ? 'menuitem selected' : 'menuitem'
                    }
                  >
                    <RepliconNavigationTab key={tab.id} tabInfo={tab} />
                  </ListItem>
                ) : null;
              })}
            </List>
          </Box>
        </Box>
        <li className="userItem" role="menuitem">
          <a
            onClick={props.handleSettingsPopUp}
            id="userDropdownOpenLink"
            className="userMenuLink"
            aria-label="User Settings"
            aria-haspopup="true"
            tabIndex={1}
          >
            <span className="menuItemIconContainer">
              <svg
                className="svgIcon"
                focusable="true"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path d="M19.44 12.99l-.01.02c.04-.33.08-.67.08-1.01 0-.34-.03-.66-.07-.99l.01.02 2.44-1.92-2.43-4.22-2.87 1.16.01.01c-.52-.4-1.09-.74-1.71-1h.01L14.44 2H9.57l-.44 3.07h.01c-.62.26-1.19.6-1.71 1l.01-.01-2.88-1.17-2.44 4.22 2.44 1.92.01-.02c-.04.33-.07.65-.07.99 0 .34.03.68.08 1.01l-.01-.02-2.1 1.65-.33.26 2.43 4.2 2.88-1.15-.02-.04c.53.41 1.1.75 1.73 1.01h-.03L9.58 22h4.85s.03-.18.06-.42l.38-2.65h-.01c.62-.26 1.2-.6 1.73-1.01l-.02.04 2.88 1.15 2.43-4.2s-.14-.12-.33-.26l-2.11-1.66zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"></path>
              </svg>
            </span>
            <span className="menuItemLabel">User Settings</span>
          </a>
        </li>
      </List>
    </>
  );
};
